export const UPDATE_FORM_STATUS = 'UPDATE_FORM_STATUS';
export const UPDATE_RECORD = 'UPDATE_RECORD';
export const UPDATE_LAST_RUN = 'UPDATE_T2202_LAST_RUN';